/**
 * Analytics on the events landing (spec §6). GA4 gtag.js and GTM already load site-wide from the site's
 * public/index.html; nothing loads here. These helpers call window.gtag only when it exists.
 *
 * The site's gtag('config') sends the first page_view on load. `trackPage` therefore skips the very first
 * call in a page's life (the initial load) and sends page_view for later in-app navigations only; pass
 * { includeInitial: true } if the site configures gtag with send_page_view: false.
 */
let calls = 0;

export function gtagAvailable() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

export function trackPage({ path, title } = {}, { includeInitial = false } = {}) {
  calls += 1;
  if (calls === 1 && !includeInitial) return false;
  if (!gtagAvailable()) return false;
  window.gtag("event", "page_view", { page_path: path ?? window.location.pathname + window.location.search, page_title: title ?? document.title, page_location: window.location.href });
  return true;
}

export function trackEvent(name, params = {}) {
  if (!gtagAvailable()) return false;
  window.gtag("event", name, params);
  return true;
}

/** Test hook. */
export function _resetAnalytics() { calls = 0; }
